import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import { DashboardIcon } from "../common/Dashboard";
import { AdminNavText } from "../../sections/AdminDashboard/shared/adminUx";
import CustomerProfile from "../common/Profile/CustomerProfile";
import useCustomerSidebarData from "../Sidebar/CustomerSidebarData";
import { pathMatches, sectionActive } from "../Sidebar/customerSidebarNav";
import "./header.css";

const NavIconWrap = ({ children }) => (
  <DashboardIcon size="regular" className="text-inherit">
    {children}
  </DashboardIcon>
);

const CustomerSidebarDrawer = ({
  auth,
  close,
  // Legacy props from CustomerHeader — kept for call-site compatibility
  isMobile: _isMobile,
  toggleDrawer: _toggleDrawer,
  isOpen: _isOpen,
  setIsOpen: _setIsOpen,
  SignUpState: _SignUpState,
  setSignUpState: _setSignUpState,
  setAuth: _setAuth,
}) => {
  const [open, setOpen] = useState(null);
  const location = useLocation();
  const pathname = location.pathname;
  const sidebarLinks = useCustomerSidebarData();

  useEffect(() => {
    const expandedIndex = sidebarLinks.findIndex((item) => sectionActive(item, pathname));
    if (expandedIndex >= 0 && sidebarLinks[expandedIndex]?.subMenu) {
      setOpen(expandedIndex);
    }
  }, [pathname]);

  if (!auth?.user) return null;

  return (
    <nav className="flex flex-col items-center justify-center lg:hidden">
      <CustomerProfile />
      <ul className="pt-2 pb-4 space-y-1 w-[200px] mt-5 lg:mt-0">
        <li>
          {sidebarLinks?.map((e, index) => {
            const itemActive = sectionActive(e, pathname);

            if (e.subMenu) {
              const expanded = open === index;
              return (
                <li key={e.linkName || index}>
                  <button
                    type="button"
                    className={`flex items-center justify-between p-2 my-2 hover:text-primaryblue w-full ${
                      expanded || itemActive ? "text-primaryblue" : "text-offblack"
                    }`}
                    aria-expanded={expanded}
                    onClick={() => setOpen(expanded ? null : index)}
                  >
                    <span className="flex items-center gap-3 min-w-0">
                      <NavIconWrap>{itemActive ? e.iconSelected : e.icon}</NavIconWrap>
                      <AdminNavText>{e.linkName}</AdminNavText>
                    </span>
                    <i
                      className="fi fi-rs-angle-down text-sm leading-none flex items-center shrink-0"
                      aria-hidden
                    />
                  </button>
                  {expanded && (
                    <ul className="transition duration-150 ease-in-out space-y-2 flex flex-col w-full">
                      {e.subMenu.map((sub) => (
                        <li key={sub.id}>
                          <NavHashLink
                            to={sub.link}
                            onClick={close}
                            className={`flex items-center gap-3 p-2 hover:text-primaryblue w-full px-5 ${
                              pathMatches(pathname, sub.link)
                                ? "text-primaryblue"
                                : "text-offblack"
                            }`}
                          >
                            {sub.icon ? <NavIconWrap>{sub.icon}</NavIconWrap> : null}
                            <AdminNavText>{sub.linkName}</AdminNavText>
                          </NavHashLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            }

            const linkActive = pathMatches(pathname, e.link);
            return (
              <Link
                key={e.linkName || index}
                to={e.link}
                onClick={() => {
                  close?.();
                  e.onClick?.();
                }}
                className={`flex items-center gap-3 p-2 hover:text-primaryblue my-2 ${
                  linkActive ? "text-primaryblue" : "text-offblack"
                }`}
              >
                <NavIconWrap>{linkActive && e.iconSelected ? e.iconSelected : e.icon}</NavIconWrap>
                <AdminNavText>{e.linkName}</AdminNavText>
              </Link>
            );
          })}
        </li>
      </ul>
    </nav>
  );
};

export default CustomerSidebarDrawer;
